module.exports = __webpack_public_path__ + "media/images/icons/outlined/codepen-d861c0c27acc384942c1f946ae739336.svg";